(function() {

    function onContactFormSubmit(event) {

        var formEl = event.target;

        //Prevent duplicate submission
        var submitEl = formEl.querySelector("button.wizard__submit");
        submitEl.disabled = true;

        //Set the url
        let url = "https://www.wizardscreens.com/wp-admin/admin-ajax.php?patio_gurus_submission=1";
        // let url = "https://wizardscreens.rtdev.net/wp-admin/admin-ajax.php?patio_gurus_submission=1&XDEBUG_SESSION_START=vscode"; //Testing

        formEl.action = url;

        //Add token
        var senderToken = "RUdKcEnMuIgrGj1KXpUdSIotyQndnyX1";
        var senderTokenEl = document.createElement('input');
        senderTokenEl.type = "hidden";
        senderTokenEl.name = "sender_token";
        senderTokenEl.value = senderToken;
        formEl.appendChild(senderTokenEl);
    }


    document.addEventListener( 'DOMContentLoaded', function(event) {
        
        var contactFormEl = document.getElementById("contact-form");

        //Check if this was just submitted
        var qsParams = new URLSearchParams(window.location.search);

        if(qsParams.has("submit_success") || qsParams.has("submit_error")) {

            var msgBlock = contactFormEl.querySelector(".submit-message");
            var msgBlockP = msgBlock.querySelector("p");

            if(qsParams.get("submit_success") == "1") {
                msgBlockP.innerText = "Thank you for submitting your request! A representative will get back to you shortly.";
                msgBlock.classList.add("active", "success");
            }
            else if(qsParams.get("submit_error") == "1") {
                msgBlockP.innerText = "There was an error submitting your request.";
                msgBlock.classList.add("active", "error");
            }
        }

        if(contactFormEl) {
            contactFormEl.addEventListener('submit', onContactFormSubmit);
        }

    });

})();